import { jsx } from "react/jsx-runtime";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import { validateTidalLicense } from "../../base/index.js";
function SentimentVerySatisfied(props) {
  return /* @__PURE__ */ jsx(
    SentimentVerySatisfiedIcon,
    {
      "data-testid": "SentimentVerySatisfied",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "SentimentVerySatisfied",
      "data-tidal-icon-meta": "ratings,sentiments"
    }
  );
}
SentimentVerySatisfied.tidalIconMeta = {
  categories: "ratings,sentiments",
  name: "SentimentVerySatisfied"
};
validateTidalLicense();
export {
  SentimentVerySatisfied
};
//# sourceMappingURL=SentimentVerySatisfied.js.map
